const breakpoints = {
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1920,
} as const;

export const forPhone = `@media (max-width: ${breakpoints.sm - 1}px)`; // < 600px
export const forMobile = `@media (max-width: ${breakpoints.md - 1}px)`; // < 900px
export const forTablet = `@media (min-width: ${breakpoints.sm}px) and (max-width: ${breakpoints.md - 1}px)`; // 600–899px
export const forDesktop = `@media (min-width: ${breakpoints.md}px)`; // ≥ 900px
export const forNarrow = `@media (max-width: ${breakpoints.lg - 1}px)`; // < 1200px
export const forWide = `@media (min-width: ${breakpoints.lg}px)`; // ≥ 1200px
export const forUltraWide = `@media (min-width: ${breakpoints.xl}px)`; // ≥ 1920px

export const forHover = '@media (hover: hover) and (pointer: fine)';
